
import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { readUserProfile, readHasAdminAccess } from '@/store/main/getters';
import { commitSwitchLanguage } from '@/store/admin/mutations';
import { readAdminUsers, readPatients, readLanguage } from '@/store/admin/getters';
import { dispatchGetPatients, dispatchGetPatientsNurse, dispatchGetUsers } from '@/store/admin/actions';
import ImageUploadComponent from "@/components/ImageUploadComponent.vue";
import { IUserProfile } from '@/interfaces';
import { api } from "@/api";
import { readToken } from "@/store/main/getters";
import { get } from 'http';

@Component({
  components: {
    ImageUploadComponent,
  },
})
export default class Dashboard extends Vue {

  public firstname: string = "";
  public lastname: string = "";
  public dialogDelete = false;
  public userID = -1; //For displaying a certain users if the logged in user has admin rights
  public user: IUserProfile = { id: -1, is_active: false, is_superuser: false, email: '', gender: '', postcode: -1, road: '', nationality: '', house_number: '', birthplace: '', birthday: new Date(), firstname: '', lastname: '', city: '' };

  public user_id = -1; //The user himself
  public search = "";
  public searchUser = "";
  public headers = [
    /*{
      text: 'ID',
      sortable: true,
      value: 'id',
      align: 'left',
    },*/
    {
      text: 'Name',
      sortable: true,
      value: 'firstname',
      align: 'left',
    },
    {
      text: ' Adresse ',
      sortable: true,
      value: 'adress',
      align: 'left',
    },
  ];

  public headerUser = [
    {
      text: 'Name',
      sortable: true,
      value: 'firstname',
      align: 'left',
    },
    {
      text: ' Adresse ',
      sortable: true,
      value: 'adress',
      align: 'left',
    },
  ];
  public headers_users = [
    /*{
      text: "ID",
      sortable: true,
      value: "id",
      align: "left",
    },
    {
      text: "Email",
      sortable: true,
      value: "email",
      align: "left",
    },*/
    {
      text: "Full Name",
      sortable: true,
      value: "full_name",
      align: "left",
    },
    /*{
      text: "Role",
      sortable: true,
      value: "isSuperuser",
      align: "left",
    },*/
  ];
  public headers_users_german = [
    /*{
      text: "ID",
      sortable: true,
      value: "id",
      align: "left",
    },
    {
      text: "Email",
      sortable: true,
      value: "email",
      align: "left",
    },*/
    {
      text: "Name",
      sortable: true,
      value: "full_name",
      align: "left",
    },
    /*{
      text: "Funktion",
      sortable: true,
      value: "isSuperuser",
      align: "left",
    },*/
  ];
  public items_per_page = [25, 50, 100, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }];
  public pagination = {
    rowsPerPage: 25,
  };

  get searchLabel() {
    return this.$t("search") as string;
  }

  get getHeaderUser() {
    if (this.language) {
      return this.headers_users
    } return this.headers_users_german
  }

  get users() {
    const users = readAdminUsers(this.$store);
    console.log("Here the users: " + users);
    return users;
  }

  public goToUserAll() {
    this.$router.push({ name: "main-admin-users" });
  }

  public getRole(isSuperuser: boolean) {
    if (isSuperuser) {
      return "Admin";
    } else if (this.language) {
      return "Nurse";
    }
    return "Tierpfleger*in";
  }

  public async deleteUserIni(id: number) {
    this.dialogDelete = true;
    this.userID = id;
  }

  get greetedUser() {
    const userProfile = readUserProfile(this.$store);
    this.user_id = userProfile?.id as number;
    if (userProfile) {
      if (userProfile.firstname) {
        return (userProfile.firstname + " " + userProfile.lastname);
      } else {
        return userProfile.email;
      }
    }
  }

  get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  get patients() {
    return readPatients(this.$store);
  }

  //Image----------------
  //for uploading the picture
  public imgDataUrl = "";

  public async b64Helper(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  }

  private getAdress(patID: number) {
    let house_number = "";
    let postcode;
    let city = "";
    let road = "";
    for (let p of this.patients) {
      if (p.id == patID) {
        house_number = p.house_number ?? "";
        postcode = p.postcode ?? "";
        city = p.city ?? "";
        road = p.road ?? "";
        break;
      }
    }
    var adress = "";
    if (road) {
      adress += road + " ";
    }
    if (house_number) {
      adress += house_number.toString();
    }
    if (adress != "") {
      adress += ", ";
    }
    if (postcode) {
      adress += postcode + " ";
    }
    if (city) {
      adress += city;
    }
    return adress;
  }

  private deleteUser(id) {
    console.log("We will be deleting a user with the id: " + id)
  }
  
  private b64Cleaner(b64: string) {
    let newA: String = b64.replace(
      "dataimage/pngbase64",
      "data:image/png;base64,"
    );
    let newB: String = newA.replace(
      "dataimage/jpegbase64",
      "data:image/jpeg;base64,"
    );
    //Removing padding from backend
    let newC = newB.replace(
      "=",
      ""
    )
    return newC;
  }

  //---------------------------------------


  public async mounted() {
    const userProfile = readUserProfile(this.$store);
    if (readHasAdminAccess(this.$store)) {
      await dispatchGetPatients(this.$store);
      await dispatchGetUsers(this.$store)
    } else {
      await dispatchGetPatientsNurse(this.$store);
    }
    if (userProfile) {
      var responseb64: string = "";
      await api
        .getProfilePicUser(
          readToken(this.$store),
          userProfile?.id as number
        )
        .then((response) => (responseb64 = response.data))
        .catch((error) => console.log(error));
      this.imgDataUrl = this.b64Cleaner(responseb64);
    }
    this.firstname = userProfile!.firstname;
    this.lastname = userProfile!.lastname;
  }



  get language() {
    return readLanguage(this.$store);
  }
}
